import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingBagIcon, UserIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../context/AuthContext';
import { useCart } from '../context/CartContext';

const Navbar = () => {
  const { user } = useAuth();
  const { cartCount } = useCart();

  // Determine where the user icon should link to
  const getProfileLink = () => {
    if (!user) return '/login';
    if (user.role === 'Super-Admin') return '/super-admin';
    if (user.role === 'Admin') return '/admin';
    return '/userdashboard';
  };

  return (
    <nav className="bg-secondary shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-20 items-center">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center">
            <Link to="/" className="flex items-center gap-2">
              {/* Leaf Logo Icon */}
              <svg className="h-8 w-8 text-primary" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M17,8C8,10,5.9,16.17,3.82,21.34L5.71,22l1-2.3A4.49,4.49,0,0,0,8,20C19,20,22,3,22,3,21,5,14,5.25,9,6.25S2,11.5,2,13.5a6.22,6.22,0,0,0,1.75,3.75C7,8,17,8,17,8Z" />
              </svg>
              <h1 className="font-serif text-2xl font-bold text-primary tracking-wide">
                Mohkagz<span className="text-accent">-Farms</span>
              </h1>
            </Link>
          </div>

          {/* Navigation Links */}
          <div className="hidden md:flex space-x-8">
            <Link to="/" className="text-primary hover:text-accent font-sans font-medium transition">Shop</Link>
            <Link to="/about" className="text-primary hover:text-accent font-sans font-medium transition">Our Farm</Link>
            <Link to="/track-order" className="text-primary hover:text-accent font-sans font-medium transition">Track Order</Link>
          </div>

          {/* Icons */}
          <div className="flex items-center space-x-6">
            {/* User Icon */}
            <Link to={getProfileLink()} className="text-primary hover:text-accent transition" aria-label="Account">
              <UserIcon className="h-6 w-6" />
            </Link>

            {/* Cart Icon */}
            <Link to="/checkout" className="text-primary hover:text-accent transition relative" aria-label="Cart">
              <ShoppingBagIcon className="h-6 w-6" />
              {cartCount > 0 && (
                <span className="absolute -top-2 -right-2 bg-accent text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center">
                  {cartCount}
                </span>
              )}
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
